import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "../../Styles/ann-tokens.css";
import "../../Styles/marketing-base.css";
import "./Header.css";

// Mirrors the "Ann Home B" design nav exactly: logo, two links, one CTA.
const NAV = [
  { to: "/first-principles", label: "First Principles" },
  { to: "/pricing", label: "Pricing" },
];

// Routes that open on a near-black hero instead of the site's light/
// cream background, keyed to that hero's own background color — the
// glass nav reads light or dark text to match whichever it's sitting on.
const DARK_HERO_BG = {
  "/": "#0E1014",
  "/for/staffing-firms": "#14161a",
};

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Close the mobile menu whenever the route changes
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Strengthen the nav border once the page scrolls
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onDark = location.pathname in DARK_HERO_BG;

  // The nav's translucent tint blends with whatever's actually painted
  // behind it — which, in the sliver directly under the nav, is just
  // <body>'s own background (the page's own sections start after it in
  // normal flow). Without this, that sliver stays index.css's default
  // near-white on every route, so a dark-hero page reads as a flat grey
  // band instead of blending into the hero.
  useEffect(() => {
    document.body.style.background = onDark
      ? DARK_HERO_BG[location.pathname]
      : "";
    return () => {
      document.body.style.background = "";
    };
  }, [onDark, location.pathname]);

  return (
    <nav
      className={`topnav${onDark ? " on-dark" : ""}${
        scrolled ? " scrolled" : ""
      }${open ? " open" : ""}`}
    >
      <Link to="/" className="ann-logo-link" aria-label="Ann — home">
        <img
          src={`${process.env.PUBLIC_URL}/${
            onDark ? "ann-lockup-cyan.svg" : "ann-lockup-light.svg"
          }`}
          alt="Ann"
          className="ann-logo"
        />
      </Link>

      <div className="links">
        {NAV.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => (isActive ? "is-active" : undefined)}
          >
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="right">
        <Link to="/send-a-role" className="cta">
          Send Ann a role
        </Link>
      </div>

      <button
        className="nav-toggle"
        aria-label="Menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>
    </nav>
  );
}
